/* global axios */
import ApiClient from './ApiClient';

// advup — Sub-fase 3.1 do roadmap de paridade Legal One (Cliente), ver
// .claude/specs/plans/paridade-legalone-cliente.md
class LegalClientsAPI extends ApiClient {
  constructor() {
    super('legal-clients', { accountScoped: true });
  }

  getAll({
    q,
    page = 1,
    per_page: perPage,
    person_type: personType,
    classification,
    contact_id: contactId,
  } = {}) {
    return axios.get(this.url, {
      params: {
        q,
        contact_id: contactId,
        page,
        per_page: perPage,
        person_type: personType,
        classification,
      },
    });
  }

  getById(id) {
    return axios.get(`${this.url}/${id}`);
  }

  // A senha do Meu INSS de um registro do histórico — só no clique do olho.
  // Vem como [antes, depois] na troca e como valor único na criação.
  getAuditInssPassword(clientId, auditId) {
    return axios.get(`${this.url}/${clientId}/audits/${auditId}/senha-inss`);
  }

  create(data) {
    return axios.post(this.url, { legal_client: data });
  }

  // O NOME, O SEXO E A DATA DE NASCIMENTO A PARTIR DO CPF.
  //
  // 🔴 A consulta acontece no SERVIDOR: a chave do serviço não pode chegar ao
  // navegador. E ela só DEVOLVE — quem decide o que fazer com o resultado é a
  // tela, porque um dígito errado no CPF é um CPF válido de outra pessoa.
  consultarCpf(cpf) {
    return axios.get(`${this.url}/consulta-cpf`, { params: { cpf } });
  }

  // O mesmo para empresa. Aqui não há chave (a API da CNPJá é aberta), mas o
  // teto é de 5 consultas por minuto POR IP — e como quem consulta é o
  // servidor, esse teto é da instalação inteira.
  consultarCnpj(cnpj) {
    return axios.get(`${this.url}/consulta-cnpj`, { params: { cnpj } });
  }

  update(id, data) {
    return axios.patch(`${this.url}/${id}`, { legal_client: data });
  }

  delete(id) {
    return axios.delete(`${this.url}/${id}`);
  }

  // Trocar telefone é OPERAÇÃO, não edição de campo: o servidor pode precisar
  // unificar o contato que o WhatsApp criou com o número novo. Ver
  // `Contacts::PhoneChanger`.
  changePhone(id, phoneNumber) {
    return axios.patch(`${this.url}/${id}/phone`, {
      phone_number: phoneNumber,
    });
  }

  // ─── Telefones (Sub-fase 3.2 do roadmap de paridade Legal One) ─────────
  getPhones(clientId) {
    return axios.get(`${this.url}/${clientId}/phones`);
  }

  createPhone(clientId, data) {
    return axios.post(`${this.url}/${clientId}/phones`, data);
  }

  updatePhone(clientId, id, data) {
    const base = this.url.replace('legal-clients', 'legal-client-phones');
    return axios.patch(`${base}/${id}`, data);
  }

  deletePhone(clientId, id) {
    const base = this.url.replace('legal-clients', 'legal-client-phones');
    return axios.delete(`${base}/${id}`);
  }

  // ─── E-mails (Sub-fase 3.3 do roadmap de paridade Legal One) ───────────
  getEmails(clientId) {
    return axios.get(`${this.url}/${clientId}/emails`);
  }

  createEmail(clientId, data) {
    return axios.post(`${this.url}/${clientId}/emails`, data);
  }

  updateEmail(clientId, id, data) {
    const base = this.url.replace('legal-clients', 'legal-client-emails');
    return axios.patch(`${base}/${id}`, data);
  }

  deleteEmail(clientId, id) {
    const base = this.url.replace('legal-clients', 'legal-client-emails');
    return axios.delete(`${base}/${id}`);
  }

  // ─── Endereços (Sub-fase 3.4 do roadmap de paridade Legal One) ─────────
  getAddresses(clientId) {
    return axios.get(`${this.url}/${clientId}/addresses`);
  }

  createAddress(clientId, data) {
    return axios.post(`${this.url}/${clientId}/addresses`, data);
  }

  updateAddress(clientId, id, data) {
    const base = this.url.replace('legal-clients', 'legal-client-addresses');
    return axios.patch(`${base}/${id}`, data);
  }

  deleteAddress(clientId, id) {
    const base = this.url.replace('legal-clients', 'legal-client-addresses');
    return axios.delete(`${base}/${id}`);
  }

  // ─── Dados bancários (Sub-fase 3.5 do roadmap de paridade Legal One) ───
  getBankAccounts(clientId) {
    return axios.get(`${this.url}/${clientId}/bank_accounts`);
  }

  createBankAccount(clientId, data) {
    return axios.post(`${this.url}/${clientId}/bank_accounts`, data);
  }

  updateBankAccount(clientId, id, data) {
    const base = this.url.replace(
      'legal-clients',
      'legal-client-bank-accounts'
    );
    return axios.patch(`${base}/${id}`, data);
  }

  deleteBankAccount(clientId, id) {
    const base = this.url.replace(
      'legal-clients',
      'legal-client-bank-accounts'
    );
    return axios.delete(`${base}/${id}`);
  }

  // ─── Histórico / Auditoria (Sub-fase 3.7 do roadmap de paridade Legal One) ───
  getAudits(clientId) {
    return axios.get(`${this.url}/${clientId}/audits`);
  }

  // ─── Busca de CEP (Sub-fase 3.8 do roadmap de paridade Legal One) ──────
  cepLookup(cep) {
    return axios.get(`${this.url}/cep_lookup`, { params: { cep } });
  }

  // ─── GED do Cliente (Sub-fase 4.3 do roadmap de paridade Legal One) ────
  getDocuments(clientId) {
    return axios.get(`${this.url}/${clientId}/documents`);
  }
}

export const LegalClientsApi = new LegalClientsAPI();
